import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { ProductVisual } from '../products/ProductVisual';
import { products } from '../../data/products';
interface FamilyScreenProps {
  onNext: () => void;
}
export function FamilyScreen({
  onNext
}: FamilyScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-129" data-mp="332tlwrs0hsya">
      <Reveal data-id="element-130" data-mp="2fgdbtjk9qfm0">
        <span className="font-body text-[10px] uppercase tracking-[0.22em] text-primary" data-id="element-131" data-mp="2ffv7s0rd6x3j">
          The family portrait
        </span>
      </Reveal>
      <Reveal delay={0.06} data-id="element-132" data-mp="2p4v9vt15y8ly">
        <h2 className="mt-2 font-heading text-[42px] leading-[0.95] tracking-[-0.02em] text-white" data-id="element-133" data-mp="2p66o6ms8iyrb">
          Meet the Filtek’s
        </h2>
      </Reveal>
      <Reveal delay={0.14} data-id="element-134" data-mp="2kclqkvuk06sn">
        <p className="mt-3 max-w-[300px] font-body text-[15px] leading-relaxed text-white/65" data-id="element-135" data-mp="1woavyafgb3ct">
          Same heritage. Different strengths for different jobs.
        </p>
      </Reveal>

      <Reveal delay={0.22} className="mt-8" data-id="element-136" data-mp="ixc77tpglvlf">
        <div className="rounded-[28px] bg-white p-5 shadow-[0_24px_60px_-30px_rgba(0,0,0,0.6)]" data-id="element-137" data-mp="iwkovkkvhud3">
          <div className="flex items-end justify-center gap-3" data-id="element-138" data-mp="num6s26kbnmz">
            {products.map((p, i) => <motion.div key={p.id} initial={{
            opacity: 0,
            y: 24,
            rotate: i === 0 ? -4 : i === 2 ? 4 : 0
          }} animate={{
            opacity: 1,
            y: 0,
            rotate: 0
          }} transition={{
            delay: 0.34 + i * 0.12,
            type: 'spring',
            stiffness: 240,
            damping: 20
          }} className="flex flex-col items-center" data-id="element-139" data-mp="snf96jek6jvw" data-mpi={i}>
                <ProductVisual product={p.id} className="h-[150px] w-auto" data-id="element-140" data-mp="dy9ffayhplve" />
              </motion.div>)}
          </div>
          <div className="mt-4 grid grid-cols-3 gap-2 border-t border-[rgba(1,51,43,0.1)] pt-3 text-center" data-id="element-141" data-mp="1kdjseeql10vj">
            {['Supreme', 'Easy Match', 'One Bulk Fill'].map(name => <span key={name} className="font-body text-[10px] uppercase leading-tight tracking-[0.12em] text-[rgba(1,51,43,0.55)]" data-id="element-142" data-mp="3lf9hbm1k7mqb">
                {name}
              </span>)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.5} className="mt-7" data-id="element-143" data-mp="3qf4axxcpyqf2">
        <PillButton tone="dark" full onClick={onNext} data-id="element-144" data-mp="3qg6ybvau2aq8">
          Introduce me
        </PillButton>
      </Reveal>
    </div>;
}